(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const popupOverlay = document.getElementById('newsletter-popup-overlay')
    const closeBtn = popupOverlay.querySelector('.close-popup')

    const popupShown = localStorage.getItem('popupShown')
    
    const successMessage = document.querySelector('.email-signup__message--success')
    if (successMessage && !popupShown) {
      popupOverlay.classList.add('active')
      
      localStorage.setItem('popupShown', 'true')
    }

    closeBtn.addEventListener('click', function() {
      popupOverlay.classList.remove('active')
    })

    popupOverlay.addEventListener('click', function(e) {
      if (e.target === popupOverlay) {
        popupOverlay.classList.remove('active')
      }
    })
  })
  } catch(e) { console.error(e); }
})();

})();
